import { RequestQueueRoutes } from "./RequestQueueRoutes";

const QUEUE_PATHS: string[] = Object.values(RequestQueueRoutes).flatMap((def) => [
  ...Object.values(def.paths),
  ...(def.aliases ?? []),
]);

const NORMALISED_QUEUE_PATHS = QUEUE_PATHS.map((path) => path.toLowerCase());

// Three things react-router does when it matches that the raw pathname does not show: it ignores
// any number of trailing slashes, it is case-insensitive, and it hands the pathname back with the
// diacritics still percent-encoded. Decoding has to come after the strip, or an encoded slash
// would be read as a real one and match a page the router itself would not render.
function normalise(pathname: string): string {
  const withoutTrailingSlash = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  try {
    return decodeURIComponent(withoutTrailingSlash).toLowerCase();
  } catch {
    return withoutTrailingSlash.toLowerCase();
  }
}

export function isRequestQueuePath(pathname: string): boolean {
  return NORMALISED_QUEUE_PATHS.includes(normalise(pathname));
}
